import { __, flatten } from '../../../Utils';

export const catalogDescTranslate = (lang, translations = [], defaultValue) => {
  const translation = translations.find(t => t.lang === lang);

  if (translation && translation.description.length > 0) {
    return translation.description;
  }
  return defaultValue;
};

export const marketingTranslate = (lang, translations = [], defaultValue) => {
  const translation = translations.find(t => t.lang === lang);

  if (translation && translation.value.length > 0) {
    return translation.value;
  }
  return defaultValue;
};

export const getVariantLabel = count => {
  if (count === 1) {
    return __('1 variant');
  }

  if (count < 5) {
    return `${count} ${__('varianty')}`;
  }

  return `${count} ${__('variant')}`;
};

export const normalizeVariantsAndCheckSelected = (data, selectedArray) => {
  return flatten(
    data
      .filter(d => d)
      .map(d =>
        [d].concat(
          d.complementary_products &&
            selectedArray.indexOf(d.variantId || d._id) > -1
            ? d.complementary_products.map(c =>
                Object.assign(c, {
                  type: 'compProduct',
                  parentId: d.variantId,
                }),
              )
            : [],
        ),
      ),
  );
};

export const normalizeVariants = data => {
  if (!data) {
    return [];
  }

  return flatten(
    data
      .filter(d => d)
      .map(d =>
        [d].concat(
          d.complementary_products
            ? d.complementary_products.map(c =>
                Object.assign(c, {
                  type: 'compProduct',
                  parentId: d.variantId,
                }),
              )
            : [],
        ),
      ),
  );
};



// WEBPACK FOOTER //
// ./src/Containers/ProductCatalog/CatalogUtils/index.jsx